export const searchListData = [
  {
    id: "1",
    name: "Bell MX-9 MIPS Helmet",
    oldPrice: "6000",
    newPrice: "5000",
    image: "/img/helmets/helmet01.png",
  },
  {
    id: "2",
    name: "Bilmola Defender Treasure",
    oldPrice: "5500",
    newPrice: "4400",
    image: "/img/helmets/helmet02.png",
  },
  {
    id: "3",
    name: " Cobalt HV Gray",
    oldPrice: "9000",
    newPrice: "6600",
    image: "/img/helmets/helmet03.png",
  },
];
